import React, { FC } from 'react';
import { Action, Button, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import styles from './LandscapeProjectsAddProjectsImpactIndicatorsOrganism.module.css';
import useReorder from '../../../hooks/useReorder/useReorder';
import { LandscapeIndicatorType } from '../../../store/landscapeAPI/landscape/landscape-indicator-type';

export interface TableItem {
  name: string;
  type: LandscapeIndicatorType;
  sortOrder: number;
  id: string;
}

interface LandscapeProjectsAddProjectsImpactIndicatorsOrganismProps {
  handleDelete: (id: string) => void;
  tableItems: TableItem[];
  setTableItems: (items: TableItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
}

const LandscapeProjectsAddProjectsImpactIndicatorsOrganism: FC<
  LandscapeProjectsAddProjectsImpactIndicatorsOrganismProps
> = ({ handleDelete, tableItems, setTableItems, changeOrderEnabled }) => {
  const [litems, moveItem] = useReorder<TableItem>(
    tableItems,
    setTableItems,
    true
  );

  return (
    <SortableTable
      data={tableItems}
      columns={[
        { label: 'Indicator Name', key: 'name' },
        { label: 'Type', key: 'type' },
        { label: '' },
      ]}
      renderRow={(row, index) => (
        <TableRow key={row.id}>
          <Label content={row.name} />
          <Label content={row.type} />
          <div className={styles.sortActionsWrapper}>
            {changeOrderEnabled && tableItems.length > 1 && index !== 0 && (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  moveItem(row.sortOrder, litems[index - 1].sortOrder);
                }}
              >
                ↑
              </Button>
            )}
            {changeOrderEnabled &&
              litems.length > 1 &&
              index !== litems.length - 1 && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    moveItem(row.sortOrder, litems[index + 1].sortOrder);
                  }}
                >
                  ↓
                </Button>
              )}
          </div>
          <Action
            type="delete"
            itemName={row.name}
            size="sm"
            onClick={() => {
              handleDelete(row.id);
            }}
          ></Action>
        </TableRow>
      )}
      showEditButtonHeader={false}
    />
  );
};

export default LandscapeProjectsAddProjectsImpactIndicatorsOrganism;
